/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// TODO Unit testy.
/**
 * Poskytovatel zdrojů pro zobrazování HTML img elementů..
 * Implementuje návrhový vzor Factory pro tvorbu zdrojů.
 * Pro každé zapůjčení je vytvořený nový zdroj.
 * Místo vracení zdroje ho vždy smaže.
 * @implements {ViewerSourceCreator}
 */
class DivViewerSourceCreator {
  /**
   * Vytvoří instanci.
   * @param {PoolFactory} poolFactory
   * @param {ViewerSourceFactory} sourceFactory Továrna na zdroje, které se poskytují.
   */
  constructor(poolFactory, sourceFactory) {
    this.pool = poolFactory.create(sourceFactory);
    this.sourceFactory = sourceFactory;
  }

  /** @inheritdoc */
  delete(source) {
    return new Promise((resolve) => resolve(this.pool.delete(source)));
  }

  /** @inheritdoc */
  destroy() {
    this.pool.destroy();
  }

  /** @inheritdoc */
  getLent() {
    return this.pool.getLent();
  }

  /** @inheritdoc */
  getMax() {
    return this.pool.getMax();
  }

  /** @inheritdoc */
  lend(parentEl, scheduleInfo) {
    return new Promise((resolve) => {
      // Nastaví se rodičovský element továrny, aby do něj vytvářela nové zdroje.
      // Nastavuje se dopředu, aby byl rodičovský element dostupný v okamžiku plnění bazénu.
      this.sourceFactory.setParentEl(parentEl);
      const source = this.pool.lend();
      source.setParentEl(parentEl);
      return resolve(source);
    });
  }

  /** @inheritdoc */
  receive(source) {
    return new Promise((resolve) => resolve(this.pool.delete(source)));
  }

  /** @inheritdoc */
  replace() {
    // Není třeba nic provést.
    return Promise.resolve();
  }
}

export default DivViewerSourceCreator;
